export default "__VITE_ASSET__rZ72D9ul__"